import React from 'react';
import AppHeader from '../../components/Header/Header';
import AppLayout from '../../components/layout';
import BannerSection from '../../components/ui/BannerSection';
import InstituicaoMenu from '../../components/ui/InstituicaoMenu';
import SectionHeading from '../../components/SectionHeading';
import BreadcrumbNav from '../../components/ui/BreadcrumbNav';

const caminho = [
    { label: 'Home', href: '/', icon: 'bi bi-house-door' },
    { label: 'Instituição' },
    { label: 'Apoio Social' }
];

function ApoioSocial() {
    return (
        <>
            <header id='header'>
            <AppHeader />
            </header>
            <BannerSection
            title="Apoio Social"
            subtitle="Apoio Social do Instituto Superior Politécnico Atlântida"
            description={`O Instituto Superior Politécnico Atlântida tem um compromisso com a responsabilidade social, oferecendo apoio a pessoas vulneráveis.`}
            backgroundImage={require('../../assets/BannerANU_ispa.jpg')} 
            backgroundId="instituition-Banner"
            />
            <BreadcrumbNav items={caminho} />   
            <main className="px-3 px-md-5 px-xl-5 px-xxl-5 py-2">
                <br />
                <div className="row flex-row-reverse">
                    <div className="col-12 col-md-8 col-lg-9 col-xl-9 col-xxl-9">
                        <br />
                        <div className="details-magazine">
                            <p className="f-reg">
                                <SectionHeading title="Ação Social" />
                                <br />
                                Dada a localização regional e culminando com a Visão do Grupo Isabelinha em ser uma instituição com o espírito altruísta 
                                ajudando as pessoas mais vulneráveis da sociedade, a responsabilidade social está focada nos seguintes programas:<br /><br />
                                1 - A Instituição anualmente oferece, num projeto denominado “Necessitados da Ação Social”, mais de 20 bolsas comparticipadas 
                                e 10 não comparticipadas, desde que os mesmos apresentem certificado de pobreza.<br /><br />
                                2 - Desenvolve consultas de rotina aos trabalhadores nos Centros Médicos Atlântida ou do Grupo Isabelinha com um plafom mensal não renovável;<br /><br />
                                3 - No âmbito da Psicologia, oferece consultas a preços acessíveis a partir do centro e da Incubadora de Empresas.<br /><br />
                                4 - Trabalha na alfabetização de crianças e adultos fora do sistema de ensino.<br /><br />
                            </p>
                            <br />
                        </div>
                    </div>
                    <div className="col-12 col-md-4 col-lg-3 col-xl-3 col-xxl-3">
                        <InstituicaoMenu />
                    </div>
                </div>
                <br /><br /><br />
            </main>
            <AppLayout />
        </>
    );
}

export default ApoioSocial;
